import { Box } from '@mui/system';
import { memo, ReactElement } from 'react';

export interface SessionStatusLayoutProps {
  sessionTime: ReactElement;
  logoutButton?: ReactElement;
  extendDialog?: ReactElement;
  logoutDialog?: ReactElement;
}

export const SessionStatusLayout = memo(function SessionStatusLayout({
  sessionTime,
  logoutButton,
  extendDialog,
  logoutDialog,
}: SessionStatusLayoutProps): ReactElement {
  return (
    <>
      <Box
        width='100%'
        boxSizing='border-box'
        padding={2}
        pb={1}
        pt={1}
        display='flex'
        flexDirection='row'
        alignItems='center'
        justifyContent='space-between'
        bgcolor='rgb(216, 216, 216)'
      >
        {sessionTime}
        <Box display='flex' flexDirection='row' alignItems='center' gap={2}>
          {logoutButton}
        </Box>
      </Box>

      {extendDialog}
      {logoutDialog}
    </>
  );
});
